import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { Button } from '@mui/material';

import useLicenseInfo from 'hooks/use-license-info';
import useTrialModal from 'hooks/use-trial-modal';

import ChevronUpDoubleIcon from './assets/chevron-up-double.svg';
import useStyles from './styles';

interface Props {
    className?: string;
}

const UpgradeLicenseButton: React.FC<Props> = ({ className }) => {
    const history = useHistory();
    const { modal, onAnchorClick } = useTrialModal();
    const { classes, cx } = useStyles();

    const goToUserInfo = useCallback(() => history.push('/userinfo'), [history]);
    const { isTrial, canUpgrade } = useLicenseInfo();

    if (!isTrial && !canUpgrade) {
        return null;
    }

    return (
        <>
            <Button
                className={cx(classes.root, className)}
                onClick={isTrial ? onAnchorClick : goToUserInfo}
                variant="contained"
                disableElevation
                disableFocusRipple
                disableRipple
                startIcon={isTrial ? null : <ChevronUpDoubleIcon />}
                data-testid="trialActivation"
            >
                {isTrial ? 'Start 30-day trial' : 'Upgrade plan'}
            </Button>
            {modal}
        </>
    );
};

export default observer(UpgradeLicenseButton);
